import { post } from "../../utils/Backend";
import { useLongfansMock } from "../../global/GlobalMock";
import { qaFeedMocks } from "./QaFeedMock";
import type {
  QaEngagementParam,
  QaEngagementState,
  QaFeedListQuery,
  QaFeedListResult,
  QaFeedQuestion,
  QaQuotaQuery,
  QaQuotaResult,
  QaSubmitQuestionPayload,
  QaSubmitReplyPayload,
} from "./QaFeedType";

const mockQaFeed = useLongfansMock && false;

const URL_LIST = "/lark/app/qa/listFeed";
const URL_SUBMIT = "/lark/app/qa/submitQuestion";
const URL_QUOTA = "/lark/app/qa/quota";
const URL_SUBMIT_REPLY = "/lark/app/qa/submitReply";
const URL_TOGGLE_LIKE = "/lark/app/qa/toggleLike";
const URL_TOGGLE_COLLECT = "/lark/app/qa/toggleCollect";

export const QaFeedApi = {
  async listFeed(query: QaFeedListQuery): Promise<QaFeedListResult | string> {
    if (mockQaFeed) return qaFeedMocks.listFeed(query);
    return post<QaFeedListQuery, QaFeedListResult>(URL_LIST, query, { silent: true });
  },

  async submitQuestion(payload: QaSubmitQuestionPayload): Promise<QaFeedQuestion | string> {
    if (mockQaFeed) return qaFeedMocks.submitQuestion(payload);
    return post<QaSubmitQuestionPayload, QaFeedQuestion>(URL_SUBMIT, payload);
  },

  async quota(query: QaQuotaQuery): Promise<QaQuotaResult | string> {
    if (mockQaFeed) return qaFeedMocks.quota(query);
    return post<QaQuotaQuery, QaQuotaResult>(URL_QUOTA, query, { silent: true });
  },

  async submitReply(payload: QaSubmitReplyPayload): Promise<QaFeedQuestion | string> {
    if (mockQaFeed) return qaFeedMocks.submitReply(payload);
    return post<QaSubmitReplyPayload, QaFeedQuestion>(URL_SUBMIT_REPLY, payload);
  },

  async toggleLike(param: QaEngagementParam): Promise<QaEngagementState | string> {
    if (mockQaFeed) return qaFeedMocks.toggleLike(param);
    return post<QaEngagementParam, QaEngagementState>(URL_TOGGLE_LIKE, param, { silent: true });
  },

  async toggleCollect(param: QaEngagementParam): Promise<QaEngagementState | string> {
    if (mockQaFeed) return qaFeedMocks.toggleCollect(param);
    return post<QaEngagementParam, QaEngagementState>(URL_TOGGLE_COLLECT, param, { silent: true });
  },
};
